/**
 * @description 过滤对应的属性值
 * @param {object} obj
 * @param {array} arr 扩展过滤属性名
 * @returns {object} 返回新的对象
 */
export function filterProperty(obj, arr = []) {
  for (let i = 0; i < arr.length; i++) {
    delete obj[arr[i]];
  }
  return obj;
}



// WEBPACK FOOTER //
// ./src/routes/routes/electronicInvoice/utils/util.js